import classnames from 'classnames';
import React from 'react';

import componentTypes from './component-types';

export default (items, stateProps, className = 'navigationBar__navItem') => {
  return items
    .map(item => {
      const isValid = !item.validate || item.validate(stateProps);
      const Item = componentTypes(item.type);
      const key = item.name;
      const props = item.additionalProps
        ? item.additionalProps(stateProps)
        : {};
      const classNames = item.classNames
        ? item.classNames(stateProps)
        : undefined;

      if (!Item || !isValid) {
        return;
      }

      return (
        <li
          className={classnames(className, classNames)}
          key={key}
          id={item.id}
        >
          <Item item={item} {...props} />
        </li>
      );
    })
    .filter(Boolean);
};
